import { render, staticRenderFns } from "./materialsDialog.vue?vue&type=template&id=c474f814"
import script from "./materialsDialog.vue?vue&type=script&lang=js"
export * from "./materialsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports